import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '@ca/core/services';
import { tap } from 'rxjs/operators';
import { AvatarModel } from 'src/app/shared/components/avatar/avatar.component';
import { PERMISSION_MYACCESSTOKENS, PERMISSION_MYLAB_MODULES, PERMISSION_MYLAB_WORKFLOWS } from 'src/app/shared/constants/constants';
import { UserInfo } from '../../../models/user-info.model';
import { ExperimentalFeaturesService } from '../../../services/experimental-features.service';

@Component({
    selector: 'ca-sidebar-nav-header',
    templateUrl: './sidebar-nav-header.component.html',
    styleUrls: ['./sidebar-nav-header.component.scss'],
})
export class SidebarNavHeaderComponent implements OnInit {
    @Input() userInfo: UserInfo;
    @Input() isNavbarOpen: boolean;
    @Input() isLoggedIn: boolean;

    @Output() onLogout = new EventEmitter<void>();
    @Output() onLogin = new EventEmitter<void>();

    avatarModel: AvatarModel;
    isMEDProjectEnabled = this.experimentalFeaturesService.isMEDProjectActive;

    logoPath = this.isMEDProjectEnabled ? 'assets/images/MED-RDP-logos/logo-RDP-with-padding.svg' : 'assets/images/arivis-cloud-logos/arivis-cloud-logo.svg';
    title = this.isMEDProjectEnabled ? 'Zeiss RDP' : 'arivis Cloud';

    PERMISSION_MYACCESSTOKENS = PERMISSION_MYACCESSTOKENS;
    PERMISSION_MYLAB_WORKFLOWS = PERMISSION_MYLAB_WORKFLOWS;
    PERMISSION_MYLAB_MODULES = PERMISSION_MYLAB_MODULES;

    constructor(
        private experimentalFeaturesService: ExperimentalFeaturesService,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.userService.profileImage$
            .pipe(
                tap(() => {
                    this.avatarModel = { avatarUserId: this.userInfo.sub };
                }),
            )
            .subscribe();
    }

    logout(): void {
        this.onLogout.emit();
    }

    login(): void {
        this.onLogin.emit();
    }

    get shouldComponentShowcaseBeShown(): boolean {
        return this.experimentalFeaturesService.areExperimentalFeaturesEnabled;
    }

    hasPermissions(requiredPermissions: string[]): boolean {
        return this.userService.hasPermissions(requiredPermissions);
    }
}
